<div class="modal-header border-0 pb-0 pt-4">
  <div class="d-flex align-items-center gap-3">
    <div class="error-icon-wrap">
      <img src="assets/images/virtusa-icons/warning.svg" alt="warning" width="20" height="20" />
    </div>
    <div>
      <h4 class="modal-title error-title mb-0">File Validation Failed</h4>
      <span class="error-subtitle">Swagger Validation Failed</span>
    </div>
  </div>
  <button type="button" class="accello-icon-btn ms-auto" (click)="activeModal.dismiss('Cross click')">
    <img src="assets/images/virtusa-icons/close.svg" alt="close" />
  </button>
</div>

<div class="modal-body pt-2 px-4 pb-4">
  <div class="error-message-box">
    <p class="error-main-text">{{ errorMessage }}</p>
    <p class="error-static-intro">There are several critical mismatches:</p>
    <ol class="error-list">
      <li>
        <strong>Authentication:</strong> The task explicitly requires user login, but the Swagger
        specification does not contain any endpoints for user authentication, session management,
        or login functionality.
      </li>
      <li>
        <strong>API Onboarding:</strong> The task's core requirement is to 'onboard a new API'. The
        provided API only allows managing generic 'objects'. There are no endpoints for creating,
        updating, or managing API definitions or products (which would include fields like API
        context, available countries, tags, etc.). The 'POST /objects' endpoint creates a generic
        'Object' schema, which does not align with the specific structured data required for
        'onboarding an API'.
      </li>
      <li>
        <strong>Related Entities:</strong> The task mentions selecting 'Available Countries' and
        entering 'Tag your API' values. The provided API has no endpoints to retrieve a list of
        countries or manage tags, which would be necessary for populating dropdowns or validating
        input in a UI-driven onboarding process. Therefore, the given Swagger specification is
        entirely insufficient to complete the described task, as it lacks all the necessary
        functional APIs for user authentication and API onboarding/management.
      </li>
    </ol>
  </div>
</div>

<div class="modal-footer border-0 pt-0">
  <button type="button" class="btn-accello-primary" (click)="activeModal.close()">OK</button>
</div>
